import React from "react";
import "./style.css";
const Index = () => {
  return (
    <div className="static-main">
      <div className="heading">Terms Of Use</div>
      <div className="content-section">
        <div className="header">Last Updated: 07/02/2024</div>
        <div className="card-design">
          <div>
            <div className="row">
              <div className="header">
                <span className="content">
                  Welcome to Success Club, a networking club and digital social
                  platform. By accessing or using our services, you agree to be
                  bound by these Terms and Conditions. If you do not agree to
                  these terms, please do not use our services.
                </span>
              </div>
            </div>

            <div className="title">1. &nbsp;&nbsp; Introduction</div>
            <div className="row">
              <div className="header">
                1.1 &nbsp;&nbsp;
                <span className="content">
                  These Terms and Conditions govern your use of Success Club's
                  website, online chat, event platform, business competitions,
                  leaderboards, and integration with third-party platforms like
                  Facebook and LinkedIn.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                1.2. &nbsp;&nbsp;
                <span className="content">
                  By using our services, you confirm that you are at least 18
                  years old or have the legal consent of a guardian, and you
                  have the legal capacity to enter into these Terms and
                  Conditions.
                </span>
              </div>
            </div>

            <div className="title">2. &nbsp;&nbsp; Definitions</div>
            <div className="row">
              <div className="header">
                2.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  "Platform" refers to the Success Club website and any related
                  services.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                2.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  "User" or "Member" refers to any individual or entity that
                  registers for, accesses, or uses our services.
                </span>
              </div>
            </div>

            <div className="title">3.&nbsp;&nbsp; Account Registration</div>
            <div className="row">
              <div className="header">
                3.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  To access certain features of the Platform, you must register
                  and create an account
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                3.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  To access certain features of the Platform, you must register
                  and create an account
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                3.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  You agree to provide accurate, current, and complete
                  information during the registration process and to update such
                  information as necessary.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                3.3 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  You are responsible for safeguarding your account information
                  and for all activities that occur under your account.
                </span>
              </div>
            </div>

            <div className="title">4.&nbsp;&nbsp; Use of the Platform</div>
            <div className="row">
              <div className="header">
                4.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Users agree to use the Platform in accordance with all
                  applicable laws and regulations.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                4.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  You may not use the Platform for any unlawful or fraudulent
                  activities.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                4.3 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Users agree not to engage in any behavior that could harm the
                  Platform, its users, or the reputation of Success Club.
                </span>
              </div>
            </div>

            <div className="title">5.&nbsp;&nbsp; Content and Conduct</div>
            <div className="row">
              <div className="header">
                5.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Users may post, upload, or otherwise contribute content to the
                  Platform ("User Content").
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                5.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  You retain ownership of any intellectual property rights that
                  you hold in your User Content.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                5.3 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  By posting User Content, you grant Success Club a
                  non-exclusive, worldwide, royalty-free, transferable, and
                  sublicensable license to use, reproduce, distribute, prepare
                  derivative works of, and display the User Content in
                  connection with the Platform.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                5.4 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Users must not post any content that is illegal, offensive,
                  defamatory, or infringes on the rights of others.
                </span>
              </div>
            </div>

            <div className="title">6.&nbsp;&nbsp; Business Competitions</div>
            <div className="row">
              <div className="header">
                6.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Success Club may host business competitions with monetary
                  prizes.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                6.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Participants must comply with all rules and regulations
                  specific to each competition.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                6.3 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Success Club reserves the right to disqualify participants who
                  violate the competition rules or engage in unethical behavior.
                </span>
              </div>
            </div>

            <div className="title">7.&nbsp;&nbsp; Event Platform</div>
            <div className="row">
              <div className="header">
                7.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  The event platform allows users to create, promote, and attend
                  events.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                7.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Users must comply with all applicable laws and event-specific
                  terms when using the event platform.
                </span>
              </div>
            </div>

            <div className="title">8.&nbsp;&nbsp; Leaderboards</div>
            <div className="row">
              <div className="header">
                8.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Leaderboards are provided for competitive ranking of users
                  based on various metrics.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                8.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Manipulating or gaming the leaderboards is strictly
                  prohibited.
                </span>
              </div>
            </div>

            <div className="title">
              9.&nbsp;&nbsp; Integration with Third-Party Platforms
            </div>
            <div className="row">
              <div className="header">
                9.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Success Club may integrate with third-party platforms like
                  Facebook and LinkedIn.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                9.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Users agree to comply with the terms of service of these
                  third-party platforms.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                9.3 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Success Club is not responsible for any data or content shared
                  through third-party integrations.
                </span>
              </div>
            </div>

            <div className="title">10.&nbsp;&nbsp; Privacy</div>
            <div className="row">
              <div className="header">
                10.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Our Privacy Policy outlines how we collect, use, and protect
                  your personal information.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                10.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  By using the Platform, you consent to the collection and use
                  of your information as described in our Privacy Policy.
                </span>
              </div>
            </div>

            <div className="title">
              11.&nbsp;&nbsp; Use of Data for Research and Marketing
            </div>
            <div className="row">
              <div className="header">
                11.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Success Club may use your data for research or marketing
                  initiatives, including but not limited to SMS, email, and
                  other forms of communication, within the boundaries of the
                  law.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                11.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  You agree to receive communications from Success Club for
                  these purposes. You can optout of marketing communications at
                  any time by following the unsubscribe instructions provided in
                  the communications.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                11.3 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Success Club will ensure that all data usage complies with
                  applicable data protection and privacy laws.
                </span>
              </div>
            </div>

            <div className="title">
              12.&nbsp;&nbsp; Disclaimers and Limitation of Liability
            </div>
            <div className="row">
              <div className="header">
                12.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  The Platform is provided "as is" and "as available" without
                  warranties of any kind, either express or implied.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                12.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Success Club does not warrant that the Platform will be
                  uninterrupted, secure, or free of errors.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                12.3 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  To the fullest extent permitted by law, Success Club shall not
                  be liable for any indirect, incidental, special,
                  consequential, or punitive damages arising out of or in
                  connection with your use of the Platform.
                </span>
              </div>
            </div>

            <div className="title">13.&nbsp;&nbsp; Indemnification</div>
            <div className="row">
              <div className="header">
                13.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  You agree to indemnify and hold harmless Success Club, its
                  affiliates, and their respective officers, directors,
                  employees, and agents from any claims, liabilities, damages,
                  losses, and expenses, including reasonable attorney's fees,
                  arising out of or in any way connected with your use of the
                  Platform or violation of these Terms and Conditions.
                </span>
              </div>
            </div>

            <div className="title">14.&nbsp;&nbsp; Termination</div>
            <div className="row">
              <div className="header">
                14.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Success Club reserves the right to suspend or terminate your
                  account and access to the Platform at any time, without
                  notice, for conduct that we believe violates these Terms and
                  Conditions or is harmful to other users of the Platform.
                </span>
              </div>
            </div>

            <div className="title">
              15.&nbsp;&nbsp; Governing Law and Dispute Resolution
            </div>
            <div className="row">
              <div className="header">
                15.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  These Terms and Conditions shall be governed by and construed
                  in accordance with the laws of the United States.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                15.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Any disputes arising out of or in connection with these Terms
                  and Conditions shall be resolved through binding arbitration
                  in accordance with the rules of the American Arbitration
                  Association.
                </span>
              </div>
            </div>

            <div className="title">
              16.&nbsp;&nbsp; Changes to Terms and Conditions
            </div>
            <div className="row">
              <div className="header">
                16.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Success Club reserves the right to modify these Terms and
                  Conditions at any time. Changes will be effective immediately
                  upon posting on the Platform.
                </span>
              </div>
            </div>
            <div className="row">
              <div className="header">
                16.2 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  Your continued use of the Platform after any changes to these
                  Terms and Conditions constitutes your acceptance of the new
                  terms.
                </span>
              </div>
            </div>

            <div className="title">17.&nbsp;&nbsp; Contact Us</div>
            <div className="row">
              <div className="header">
                17.1 &nbsp;&nbsp;&nbsp;
                <span className="content">
                  If you have any questions or concerns about these Terms and
                  Conditions, please contact us at info@successclub.com.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
